import React from "react";
import "../../index.css";
import "./BrandActivation.css";

const BrandActivationVideo = ({ src, text, inverted }) => {
  return (
    <>
      <div
        className={`container video-text-container ${
          inverted ? "inverse" : ""
        }`}
      >
        <div className="brand-video-container">
          <video src={src} autoPlay muted loop playsInline></video>
        </div>
        <p className="subtitle brand-video-subtitle">{text}</p>
      </div>
    </>
  );
};

export default BrandActivationVideo;
